import { render, staticRenderFns } from "./SourceCost.vue?vue&type=template&id=31de0a48"
import script from "./SourceCost.vue?vue&type=script&lang=js"
export * from "./SourceCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports